export default __webpack_public_path__ + "static/media/square-edit.74f6134d.svg";